exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".ant-select[data-v-7115b4ae] {\n  width: 220px;\n}\n", ""]);

// exports
